import React from 'react';
import { TrendingUp, Award, RefreshCcw, Users, Settings, UserCheck } from 'lucide-react';

const criteriaItems = [
  {
    icon: TrendingUp,
    title: 'Turnover £500k–£5m',
  },
  {
    icon: Award,
    title: 'Strong Local Reputation',
  },
  {
    icon: RefreshCcw,
    title: 'Stable Customer Base',
  },
  {
    icon: Users,
    title: 'Skilled Workforce',
  },
  {
    icon: Settings,
    title: 'Sound Operations',
  },
  {
    icon: UserCheck,
    title: 'Open to Succession Planning',
  },
];

const Criteria = () => {
  return (
    <section 
      id="criteria" 
      className="py-16 px-6 bg-section-alt"
      data-testid="criteria-section"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-3 tracking-tight">
          Is Your Business a Fit?
        </h2>
        <p className="text-[#5a5a5a] mb-8 max-w-2xl">
          We seek well-run UK mechanical services businesses with these characteristics:
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {criteriaItems.map((item, index) => (
            <div 
              key={index}
              className="criteria-card group p-4 rounded-lg bg-white text-center"
              data-testid={`criteria-card-${index}`}
            >
              <div className="w-10 h-10 rounded-lg bg-[#1e3a5f]/10 group-hover:bg-[#1e3a5f] flex items-center justify-center mx-auto mb-2 transition-all duration-200">
                <item.icon className="w-5 h-5 text-[#1e3a5f] group-hover:text-white transition-colors duration-200" />
              </div>
              <h3 className="text-[#1a1a1a] font-medium text-xs">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Criteria;
